import { FC, useMemo, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import styles from './CategoryCard.module.scss'
import { routes } from 'utils/routes'
import { CategoryCardProps as Props } from '../types'
import LottiePlayer from 'components/lottie-player/LottiePlayer'
import { Animations } from 'features/encyclopedia/types'
import { Broccoli, Solar, House } from 'components/assets/animations'

const CategoryCard: FC<Props> = ({ category, language }) => {
  // LOCAL STATE
  const [isHovered, setIsHovered] = useState<boolean>(false)

  // constants
  const animation = useMemo(() => {
    if (!category.hoverAnimation) return null

    switch (category.hoverAnimation) {
      case Animations.HOUSE:
        return House
      case Animations.BROCCOLI:
        return Broccoli
      case Animations.SOLAR_PANEL:
        return Solar
      default:
        return null
    }
  }, [category.hoverAnimation])

  return (
    <Link key={category.id} href={routes(language, category.slug).encyclopediaCategory}>
      <a className={styles.card} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        {(category.icon || animation) && (
          <div className={styles['img-wrapper']}>
            <figure className={styles['out-of-bounds-box']}>
              {animation ? <LottiePlayer animationData={animation} isHovered={isHovered} /> : <Image layout="fill" src={category.icon} />}
            </figure>
          </div>
        )}
        <div className={styles['colored-background']} style={{ backgroundColor: category.color }}>
          <h4>{category.title}</h4>
        </div>
      </a>
    </Link>
  )
}

export default CategoryCard
